async function getCurrentProductInfo(purchase) {
  let urlData = purchase.url;

  let url = "https://" + window.location.host + urlData + ".json";

  return new Promise( async (resolve, reject) => {
    let response = await fetch(url);
    let {product} = await response.json();
    resolve(product); 
  })
}

async function _getSkuInvData(sku){
   let y = await fetch('http://wigscom-ims.herokuapp.com/variant-inventory-api?sku='+sku,{ 
      method: 'get', 
      headers: new Headers({
          'Authorization': 'Bearer nsO_g0TQ2JF9H6DBripCDA', 
          'Content-Type': 'application/x-www-form-urlencoded'
      })
  }).then((response) => {
  	    
  		return response.json();
  	
    }).then( data =>
  	data
  	
  ).catch(error => null );
    return y;
}


async function getCurrentVariant(purchase) {
  const product = await getCurrentProductInfo(purchase);
  const variant = await getVariantNameCart(product, purchase);
  return variant;
}

function getVariantNameCart(product, purchase) {
  let currentVariantName = purchase.variant_name
  let qtyInCart = purchase.quantity

  const variant = product.variants.filter(v => v.option1 === currentVariantName)[0];
  return variant;
}

const shipStatus = {
    ONETHREE: 1,
    TWOFIVE: 2,
    TODAY: 3,
    MONDAY: 4,
    TOMORROW: 5,
    PREORDERED: 6,
    IGNORE: 7
  }

async function currentVariantData(purchase) {

  let allMessages = [];
  let variant = await getCurrentVariant(purchase);
  let product = await getCurrentProductInfo(purchase);

  let in_stock = false;
  let in_hours = false;
  let is_weekday = false;
  let is_weekday_tmr = false;
  let is_friday = false;
  let ship_msg;

    
  let var_inv_data = await _getSkuInvData(variant.sku);

  
  let qty = await var_inv_data.inventory_quantity;
  let oversell = await var_inv_data.inventory_policy;
  let price = await variant.price;
  let vendor = await product.vendor;

  let currentVariantName = purchase.variant_name;
  let qtyInCart = purchase.quantity;
  let productId;
  if(purchase.id){
    productId = purchase.id.toString();  
  }else if(purchase.url ='/products/free-mystery-gift-gwp'){
     productId = "6975420203119";
  }
  if(qty > 0) {
    in_stock = true;
  }

  let d = new Date();
  if(d.getDay() != 6 && d.getDay() != 0) {
    is_weekday = true;
  }

  if(d.getDay() != 5 && d.getDay() != 6) {
    is_weekday_tmr = true;
  }

  if(d.getDay() == 5 ) {
    is_friday = true;
  }

  let utc = d.getTime() + (d.getTimezoneOffset() * 60000);
   //winter time
  // let nd = new Date(utc - 21600000);
  //summer time
  let nd = new Date(utc - 18000000);
  let time = nd.getHours();

  if (time > 00 && time < 16) {
    in_hours = true;
  }

  // Preorder: Find matching line item
  if (document.querySelector(`.product-option[preordered="${variant.id}"]`)) {
    ship_msg = shipStatus.PREORDERED;
    allMessages.push(ship_msg);
  }
  else if (variant.id == "44081111859311") {
    ship_msg = shipStatus.IGNORE;
    allMessages.push(ship_msg);
  }
  else if (qty <= 0 && oversell == 'continue') {
    ship_msg = shipStatus.ONETHREE;
    allMessages.push(ship_msg);

      if (vendor === "TressAllure" 
            || vendor === "BelleTress" 
            || vendor === "Forever Young" 
            || vendor === "Ellen Wille"
            || vendor === "Vivica Fox") {
                ship_msg = shipStatus.TWOFIVE;
                allMessages.push(ship_msg)
            }

      if (productId === "1502103208047") {
        ship_msg = shipStatus.TODAY;
        allMessages.push(ship_msg);
      }

      if (productId === "7085355008111") {
        ship_msg = shipStatus.TODAY;
        allMessages.push(ship_msg);
      }
    
  } else if (qty < qtyInCart && oversell == 'continue') {
    ship_msg = shipStatus.ONETHREE;
    allMessages.push(ship_msg);

    if (vendor === "TressAllure" 
            || vendor === "BelleTress" 
            || vendor === "Forever Young" 
            || vendor === "Ellen Wille"
            || vendor === "Vivica Fox") {
                ship_msg = shipStatus.TWOFIVE;
                allMessages.push(ship_msg)
            }
  } else if (in_stock && is_weekday && in_hours) {
    ship_msg = shipStatus.TODAY;
    allMessages.push(ship_msg)
  } else if((in_stock && !in_hours && is_friday)|| (in_stock && !is_weekday_tmr)) {
    ship_msg = shipStatus.MONDAY;
    allMessages.push(ship_msg)
  } else if (in_stock && !in_hours) {
    ship_msg = shipStatus.TOMORROW
    allMessages.push(ship_msg)
  } else if (in_stock && !is_weekday && is_weekday_tmr) {
    ship_msg = shipStatus.TOMORROW
    allMessages.push(ship_msg)
  }

  let is_activevariant = purchase.variant_name;
  //     console.log("qty",qty);
  //     console.log("qtyInCart", qtyInCart)
  //     console.log("oversell",oversell);
  //     console.log('in_stock',in_stock);
  //     console.log('in_hours',in_hours);
  //     console.log('is_weekday',is_weekday);    
  //     console.log("currentVariantName", currentVariantName);
  //     console.log("date",d);
  // console.log(productId, 'Product ID')
  
  return ship_msg;

      
}

function updateFinalShippingMessage(allMessages) {
  let container = document.getElementById('ship-status');

  // Preorder: Cart shipping message
  let messagePrefix = "Your order";

  if (allMessages.includes(shipStatus.PREORDERED)) {
    messagePrefix = "Available items";
  }

  if (allMessages.includes(shipStatus.TWOFIVE)) {
    msg1 = `${messagePrefix} will ship in 6-10 business days`;
    ship_div = '<div style="padding-top: 2px;"><img src="https://cdn.shopify.com/s/files/1/1410/9094/files/fast_1.png?v=1637949500"> '+ msg1 +'</div>';
    container.style.color = "#c41a49"
    container.innerHTML = ship_div
  } else if (allMessages.includes(shipStatus.ONETHREE)) {
    msg2 = `${messagePrefix} will ship in 1-3 days`;
    ship_div = '<div style="padding-top: 2px"><img src="https://cdn.shopify.com/s/files/1/1410/9094/files/fast_1.png?v=1637949500"> '+ msg2 +'</div>';
    container.style.color = "#c41a49"
    container.innerHTML = ship_div
  } else if (allMessages.includes(shipStatus.TODAY)) {
    msg3 = `${messagePrefix} will ship today`;
    ship_div = '<div style="padding-top: 2px"><img src="https://cdn.shopify.com/s/files/1/1410/9094/files/fast_1.png?v=1637949500"> '+ msg3 +'</div>';
    container.style.color = "#c41a49"
    container.innerHTML = ship_div
  } else if (allMessages.includes(shipStatus.MONDAY)){
    msg4 = `${messagePrefix} will ship Monday`;
    ship_div = '<div style="padding-top: 2px"><img src="https://cdn.shopify.com/s/files/1/1410/9094/files/fast_1.png?v=1637949500"> '+ msg4 +'</div>';
    container.style.color = "#c41a49"
    container.innerHTML = ship_div
  } else if (allMessages.includes(shipStatus.TOMORROW)){
    msg5 = `${messagePrefix} will ship tomorrow`;
    ship_div = '<div style="padding-top: 2px"><img src="https://cdn.shopify.com/s/files/1/1410/9094/files/fast_1.png?v=1637949500"> '+ msg5 +'</div>';
    container.style.color = "#c41a49"
    container.innerHTML = ship_div
  } else if (allMessages.every((message) => message === shipStatus.PREORDERED || message === shipStatus.IGNORE)) {
    msg6 = `Your items will ship when back in stock`;
    ship_div = '<div style="padding-top: 2px;"><img src="https://cdn.shopify.com/s/files/1/1410/9094/files/fast_1.png?v=1637949500"> '+ msg6 +'</div>';
    container.style.color = "#c41a49"
    container.innerHTML = ship_div
  } 
}
  

async function getCartContents() {
  let response = await fetch('/cart.js');
  let cart = await response.json();

  let promisedCartProductsInformation = [];
  let allMessages = [];

  for (let item of cart.items) {
    
    promisedCartProductsInformation.push(new Promise(async (resolve, reject) => {
    if(item.variant_title != null) {
      let purchase = {url: item.url.split('?')[0],
                   variant_name: item.variant_title,
                   quantity: item.quantity,
                   id: item.product_id
                     };
      
      let currentMessage = await currentVariantData(purchase);
    allMessages.push(currentMessage);
    resolve(currentMessage);
      
    } else {
      let purchase = {url: item.url.split('?')[0],
                   variant_name: item.variant_options[0],
                   quantity: item.quantity 
                     };
      let currentMessage = await currentVariantData(purchase);
    allMessages.push(currentMessage);
      
    resolve(currentMessage);
    }
      
    
    }))
  }  
  

 Promise.all(promisedCartProductsInformation).then((array) => {
    updateFinalShippingMessage(allMessages);   

    if(allMessages.length === 0) {
      document.getElementById("ship-status").style.display = 'none'
    } else {
      document.getElementById("ship-status").style.display = "inline-block"
    }
  })
}

  setInterval(
    () => {
      let shipStatusCont = document.getElementById('ship-status');
      if (shipStatusCont.textContent.length < 1){
        let loading_msg = `<div class="loading__spinner" style="padding-top:3px;">
                            <div class="loading__spinner">
                              <svg aria-hidden="true" focusable="false" role="presentation" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
                                <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
                              </svg>
                            </div>
                          </div>`
        shipStatusCont.innerHTML = loading_msg + `<div style="padding-left: 17px"> Calculating...</div>`;
        getCartContents();     
      }
    }, 1000)
